// extracted by mini-css-extract-plugin
module.exports = {"mainColor":"#182446","container":"style_container__3vbs-","heading":"style_heading__QbNLj","list":"style_list__1ytTn"};